import axios from 'axios';
import type {
  AnsweringServiceServiceLevel,
  IGetAnsweringServiceProductBillingDetailsResponse,
} from '@/app-package';

/**
 * Fetches the billing details to display for user's signing up for an Answering Service.
 * @param serviceLevel The level at which the service is being requested (org or user).
 * @param startDate The start date for the new subscription to begin for the requesting user in format YYYY-MM-DD.
 */
const getAnsweringServiceProductBillingDetails = async ({
  serviceLevel,
  startDate,
}: {
  serviceLevel: AnsweringServiceServiceLevel;
  startDate: string;
}): Promise<IGetAnsweringServiceProductBillingDetailsResponse> => {
  const { data } =
    await axios.get<IGetAnsweringServiceProductBillingDetailsResponse>(
      `/answering_service/product_billing_details/${serviceLevel}`,
      {
        params: {
          startDate,
        },
      },
    );
  return data;
};

export default getAnsweringServiceProductBillingDetails;
